import React from 'react'
import './App.css'
import { Link, Redirect } from 'react-router-dom'
import Axios from 'axios'
import Select from 'react-select'
import { IoIosArrowBack } from 'react-icons/io'
import ClipLoader from 'react-spinners/ClipLoader'
import Header3 from './components/Header3'
import GooglePlacesAutocomplete from 'react-google-places-autocomplete'
import { BiMenu } from 'react-icons/bi'
import Header5 from './components/Header5'
import Header from './layouts/Header'
import SideNav from './layouts/SideNav'
import SideNavCust from './layouts/SideNavCust'
import { API_URL } from './config'
// import Autocomplete from "react-google-autocomplete";

class Addevent extends React.Component {
  constructor(props) {
    super(props)
    const isMobile = window.innerWidth <= 768
    const businessName = localStorage.getItem('businessname')
    this.state = {
      query: '',
      password: '',
      response: '',
      error: '',
      successError: '',
      errorDisplay: 'none',
      businessname: businessName,
      eventname: '',
      customOrganiserName: businessName,
      eventdate: '',
      eventid: '',
      poster: '',
      theme: 'N/A',
      venue: '',
      expectednum: '',
      enddate: '',
      time: '',
      endtime: '',
      event_date: '',
      finish_date: '',
      description: '',
      spinning: 'none',
      updateDisplay: 'block',
      eventtype: '',
      provinces: '',
      createBtn: 'save-btn',
      isMobile,
      collapsed: isMobile,
    }
  }

  componentDidMount() {
    this.updateIsMobile()
    window.addEventListener('resize', this.updateIsMobile)
    const eventid = this.props.location.state.eventid

    const businessname = localStorage.getItem('businessname')
    const businessid = localStorage.getItem('businessid')
    document.title = 'Add new event / Karamale '
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateIsMobile)
  }

  updateIsMobile = () => {
    const isMobile = window.innerWidth <= 768
    this.setState((prev) => ({
      isMobile,
      collapsed: isMobile ? true : prev.collapsed, // auto-collapse only when entering mobile
    }))
  }

  handleToggle = () => {
    this.setState((prevState) => ({
      collapsed: !prevState.collapsed,
    }))
  }

  handleEventname = (event) => {
    this.setState({ eventname: event.target.value, errorDisplay: 'none' })
  }

  handleOrganiserName = (event) => {
    this.setState({
      customOrganiserName: event.target.value,
      errorDisplay: 'none',
    })
  }

  handleVenue = (event) => {
    this.setState({
      venue: event.target.value,
      errorDisplay: 'none',
    })
  }

  handleTheme = (event) => {
    this.setState({
      theme: event.target.value,
      errorDisplay: 'none',
    })
  }

  handleExpected = (event) => {
    this.setState({
      expectednum: event.target.value,
      errorDisplay: 'none',
    })
  }

  handleDate = (event) => {
    this.setState({
      event_date: event.target.value,
      errorDisplay: 'none',
    })
  }

  handleEnddate = (event) => {
    this.setState({
      finish_date: event.target.value,
      errorDisplay: 'none',
    })
  }

  handleTime = (event) => {
    this.setState({
      time: event.target.value,
      errorDisplay: 'none',
    })
  }

  handleEndtime = (event) => {
    this.setState({
      endtime: event.target.value,
      errorDisplay: 'none',
    })
  }

  handleDescription = (event) => {
    this.setState({
      description: event.target.value,
      errorDisplay: 'none',
    })
  }

  handleChange = (e) => {
    this.setState({ eventtype: e.target.value })
  }

  handleProvinces = (e) => {
    this.setState({ provinces: e.target.value })
  }

  update = () => {
    setTimeout(() => {
      this.setState({ errorDisplay: 'none' })
    }, 5000)
    const businessid = localStorage.getItem('businessid')
    const eventname = this.state.eventname
    const customOrganiserName = this.state.customOrganiserName
    const venue = this.state.venue
    const theme = this.state.theme
    const expectednum = this.state.expectednum
    const time = this.state.time
    const endtime = this.state.endtime
    const description = this.state.description
    const finish_date = this.state.finish_date
    const event_date = this.state.event_date
    const eventtype = this.state.eventtype
    const province = this.state.provinces

    // alert(venue);

    if (eventtype === '') {
      this.setState({
        error: 'Please select event type',
        errorDisplay: 'block',
        successError: 'error-login',
        updateDisplay: 'block',
        spinning: 'none',
      })
    } else if (province === '') {
      this.setState({
        error: 'Please select the hosting province',
        errorDisplay: 'block',
        successError: 'error-login',
        updateDisplay: 'block',
        spinning: 'none',
      })
    } else if (this.state.eventname.trim() === '') {
      this.setState({
        error: 'Please enter event name',
        errorDisplay: 'block',
        successError: 'error-login',
        updateDisplay: 'block',
        spinning: 'none',
      })
    } else if (this.state.venue.trim() === '') {
      this.setState({
        error: 'Please enter venue',
        errorDisplay: 'block',
        successError: 'error-login',
        updateDisplay: 'block',
        spinning: 'none',
      })
    } else if (theme.trim() === '') {
      this.setState({
        error: 'Please enter a theme',
        errorDisplay: 'block',
        successError: 'error-login',
        updateDisplay: 'block',
        spinning: 'none',
      })
    } else if (this.state.expectednum.trim() === '') {
      this.setState({
        error: 'Enter estimated Number of Attendees',
        errorDisplay: 'block',
        successError: 'error-login',
        updateDisplay: 'block',
        spinning: 'none',
      })
    } else if (event_date === '') {
      this.setState({
        error: 'Enter the event date',
        errorDisplay: 'block',
        successError: 'error-login',
        updateDisplay: 'block',
        spinning: 'none',
      })
    } else if (finish_date === '') {
      this.setState({
        error: 'Enter the event end date',
        errorDisplay: 'block',
        successError: 'error-login',
        updateDisplay: 'block',
        spinning: 'none',
      })
    } else if (this.state.time.trim() === '') {
      this.setState({
        error: 'Enter event time',
        errorDisplay: 'block',
        successError: 'error-login',
        updateDisplay: 'block',
        spinning: 'none',
      })
    } else if (this.state.endtime.trim() === '') {
      this.setState({
        error: 'Enter event end time',
        errorDisplay: 'block',
        successError: 'error-login',
        updateDisplay: 'block',
        spinning: 'none',
      })
    } else if (this.state.description.trim() === '') {
      this.setState({
        error: 'Enter description',
        errorDisplay: 'block',
        successError: 'error-login',
        updateDisplay: 'block',
        spinning: 'none',
      })
    } else {
      this.setState({
        createBtn: 'btn-disabled',
        spinning: 'block',
        updateDisplay: 'none',
      })
      const data = new FormData()
      data.append('query', 'ADDEVENT')
      data.append('subquery', 'ADDEVENT')
      data.append('visa', '1')
      data.append('cash', '0')
      data.append('accountid', businessid)
      data.append('event', eventname)
      data.append('customOrganiserName', customOrganiserName)
      data.append('venue', venue)
      data.append('theme', theme)
      data.append('expected', expectednum)
      data.append('startdate', event_date)
      data.append('enddate', finish_date)
      data.append('starttime', time)
      data.append('endtime', endtime)
      data.append('description', description)
      data.append('eventtype', eventtype)
      data.append('province', province)

      Axios({
        method: 'post',
        url: `${API_URL}/apps/kscanner/webservices.php`,
        data: data,
        withCredentials: true,
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
        .then((response) => {
          console.log(response.data.status)
          if (response.data.status === 'success') {
            this.props.history.push('/dashboard')
          } else {
            this.setState({
              error: response.data.message,
              errorDisplay: 'block',
              successError: 'error-login',
              createBtn: 'save-btn',
              spinning: 'none',
              updateDisplay: 'block',
            })
          }
          console.log('Event created:', response.data.message)
        })
        .catch((error) => {
          this.setState({
            error: error.response?.data || error.message,
            errorDisplay: 'block',
            successError: 'error-login',
            createBtn: 'save-btn',
            spinning: 'none',
            updateDisplay: 'block',
          })
          console.error('Error creating event:', error.response?.data || error.message)
        })
    }
  }

  close = () => {
    this.setState({ errorDisplay: 'none' })
  }

  render() {
    if (localStorage.getItem('businessname') === null) {
      return <Redirect to="/login" />
      //   return exit(1);
    } else {
    }
    const businessname = localStorage.getItem('businessname')
    const { eventtype, provinces } = this.state
    const today = new Date().toISOString().split('T')[0]

    const data = [
      { label: 'Beauty pageant', value: 'beauty pageant' },
      { label: 'Fashion show', value: 'Fashion Show' },
      { label: 'Product launch', value: 'product launch' },
      { label: 'Baby shower', value: 'baby shower' },
      { label: 'Bachelor party', value: 'bachelor party' },
      { label: 'Birth day celebration', value: 'birth day celebration' },
      { label: 'Music festival', value: 'music festival' },
      { label: 'Food festival', value: 'food festival' },
      { label: 'Street party', value: 'street party' },
      { label: 'Festival', value: 'festival' },
      { label: 'PS5', value: 'PS5' },
      { label: 'Religious', value: 'religious' },
      { label: 'Music concert', value: 'music concert' },
      { label: 'Business gathering', value: 'business gathering' },
      { label: 'Networking', value: 'networking' },
      { label: 'Movie night', value: 'movie night' },
      { label: 'color frenzy', value: 'color frenzy' },
      { label: 'Culture and tradition', value: 'culture and tradition' },
      { label: 'Tea party', value: 'tea party' },
      { label: 'Team building', value: 'team building' },
      { label: 'Woman empowerment', value: 'woman empowerment' },
      { label: 'Man empowerment', value: 'man empowerment' },
      { label: 'Conference', value: 'conference' },
      { label: 'Other', value: 'other' },
    ]

    const province = [
      { label: 'Eastern Cape', value: 'eastern cape' },
      { label: 'Free State', value: 'free state' },
      { label: 'Gauteng', value: 'gauteng' },
      { label: 'KwaZulu-Natal', value: 'kwaZulu-natal' },
      { label: 'Limpopo', value: 'limpopo' },
      { label: 'Mpumalanga', value: 'mpumalanga' },
      { label: 'Northern Cape', value: 'northern cape' },
      { label: 'North West', value: 'north west' },
      { label: 'Western Cape', value: 'western cape' },
    ]

    const accounttype = localStorage.getItem('accounttype')
    const { collapsed, isMobile } = this.state

    return (
      <div className="view">
        {accounttype === 'customer' ? (
          <>
            {' '}
            <SideNavCust collapsed={this.state.collapsed} onToggle={this.handleToggle} />
            <Header />
          </>
        ) : accounttype === 'business' ? (
          <>
            <SideNav collapsed={this.state.collapsed} onToggle={this.handleToggle} />
            <Header />
          </>
        ) : (
          <Header5 />
        )}
        <div
          className="container"
          style={{
            marginTop: 40,
            marginLeft: this.state.isMobile ? '0px' : this.state.collapsed ? 'auto' : 'auto',
          }}
        >
          {/* ✅ Mobile overlay when sidebar is open */}
          {isMobile && !collapsed && (
            <div className="mobile-overlay active" onClick={this.handleToggle} />
          )}

          {this.state.isMobile && this.state.collapsed && (
            <label className="mobile-toggle" onClick={this.handleToggle}>
              <BiMenu size={25} />
            </label>
          )}
          <div className="row justify-content-center just-container-insid pb-5">
            <div className="col-lg-7 pl-0 pr-0">
              <div className=" BoxDashboardContainer mt-5 mb-4 mrgin-search pl-0 pr-0">
                <div className="row align-self-center justify-content-center">
                  <div className="item-list p-0">
                    <div className="col-lg-4 col-6 pl-0 pr-0">
                      <button onClick={() => this.props.history.goBack()} className="link-btn">
                        <IoIosArrowBack size={25} />
                        Back &nbsp;
                      </button>
                    </div>

                    <div className="col-lg-8 col-6 text-right p-0">
                      {/* <label className="back-arrow mb-0">
                        <button
                          type="button"
                          className={this.state.createBtn}
                          onClick={() => this.update()}
                          disabled={
                            this.state.spinning === "block" ? true : false
                          }
                        >
                          <span
                            style={{
                              display: this.state.updateDisplay,
                            }}
                          >
                            Create
                          </span>
                          <span
                            style={{
                              display: this.state.spinning,
                            }}
                          >
                            <ClipLoader
                              color={"grey"}
                              loading={true}
                              // css={override}
                              size={20}
                            />
                          </span>
                        </button>
                      </label> */}
                    </div>
                  </div>
                </div>
              </div>

              <div className=" BoxDashboardContainer pl-1 pr-1">
                <div className="row align-self-center justify-content-center">
                  <div className="item-list p-0">
                    <div className="col-lg-12 pl-0">
                      <label className="ticket-title pl-0 pr-0">
                        CREATE AN EVENT AND START SELLING TICKETS RIGHT AWAY
                      </label>
                    </div>
                  </div>

                  <div className="h-divider w-100"></div>
                </div>
                <div className="col-lg-12 details-body">
                  <span>Event Details</span>
                  <br />
                  <br />
                  What kind of an event will this be?
                  <br />
                  <select
                    value={eventtype}
                    onChange={this.handleChange}
                    className="text-left mt-2 form-control"
                  >
                    <option value="" disabled>
                      Select Event Type
                    </option>
                    {data.map((obj) => (
                      <option key={obj.value} value={obj.value}>
                        {obj.label}
                      </option>
                    ))}
                  </select>
                  <br />
                  Hosting Province
                  <br />
                  <select
                    value={provinces}
                    onChange={this.handleProvinces}
                    className="text-left mt-2 form-control"
                  >
                    <option value="" disabled>
                      Select province
                    </option>
                    {province.map((obj) => (
                      <option key={obj.value} value={obj.value}>
                        {obj.label}
                      </option>
                    ))}
                  </select>
                  <br />
                  Event Name
                  <br />
                  <input
                    type="text"
                    value={this.state.eventname}
                    onChange={this.handleEventname}
                    className="edit-input form-control"
                  />{' '}
                  <br />
                  Organizer Name (Custom Input)
                  <br />
                  <input
                    type="text"
                    placeholder="If not set, defaults to account name"
                    value={this.state.customOrganiserName}
                    onChange={this.handleOrganiserName}
                    className="edit-input form-control"
                  />
                  <br />
                  <label>Venue</label>
                  <br />
                  {/* <GooglePlacesAutocomplete
                    apiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY}
                    styles={{
                      textInputContainer: {
                        backgroundColor: "grey",
                      },
                      textInput: {
                        height: 38,
                        color: "#5d5d5d",
                        fontSize: 16,
                      },
                    }}
                    textInputProps={{
                      onChange: (text) => {
                        this.handleVenue(text);
                      },
                    }}
                    selectProps={{
                      onChange: (data, details = null) =>
                        this.setState({ venue: data["value"]["description"] }),
                      fetchDetails: true,
                      placeholder: "Enter address or zip code",
                      // defaultInputValue: this.state.venue,
                    }}
                  /> */}
                  <input
                    type="text"
                    value={this.state.venue}
                    onChange={this.handleVenue}
                    className="edit-input form-control"
                  />
                  <br />
                  Theme
                  <br />
                  <input
                    type="text"
                    value={this.state.theme}
                    onChange={this.handleTheme}
                    className="edit-input form-control"
                  />
                  <br />
                  Estimated Number of Attendees
                  <br />
                  <input
                    type="text"
                    value={this.state.expectednum}
                    onChange={this.handleExpected}
                    className="edit-input form-control"
                  />
                  <br />
                  Start Date
                  <br />
                  <input
                    type="date"
                    placeholder="Set date"
                    value={this.state.event_date}
                    min={today}
                    onChange={this.handleDate}
                    className="edit-input form-control"
                  />
                  <br />
                  End Date
                  <br />
                  <input
                    type="date"
                    placeholder="End date"
                    value={this.state.finish_date}
                    min={this.state.event_date != '' ? this.state.event_date : today}
                    onChange={this.handleEnddate}
                    className="edit-input form-control"
                  />
                  <br />
                  Start Time
                  <br />
                  <input
                    type="time"
                    placeholder="Set time"
                    value={this.state.time}
                    onChange={this.handleTime}
                    className="edit-input w-100 form-control"
                  />
                  <br />
                  End time
                  <br />
                  <input
                    type="time"
                    placeholder="End time"
                    value={this.state.endtime}
                    onChange={this.handleEndtime}
                    className="edit-input form-control"
                  />
                  <br />
                  Description
                  <br />
                  <textarea
                    value={this.state.description}
                    onChange={this.handleDescription}
                    className="edit-input form-control"
                  />
                  <div className="alert alert-info p-2">
                    <span>Refunds are off by default.</span>
                    <br />
                    If you'd like to allow ticket buyers to request refunds, you can enable this in
                    the Edit Event screen before ticket sales begin.
                  </div>
                </div>

                <div className="col-12 text-right">
                  <label className="back-arrow mb-0">
                    <button
                      type="button"
                      className={this.state.createBtn}
                      onClick={() => this.update()}
                      disabled={this.state.spinning === 'block' ? true : false}
                    >
                      <span
                        style={{
                          display: this.state.updateDisplay,
                        }}
                      >
                        Create
                      </span>
                      <span
                        style={{
                          display: this.state.spinning,
                        }}
                      >
                        <ClipLoader
                          color={'grey'}
                          loading={true}
                          // css={override}
                          size={20}
                        />
                      </span>
                    </button>
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
        <br />
        <br />
        <div
          className={this.state.successError}
          style={{ display: this.state.errorDisplay, textAlign: 'center' }}
          onclick={() => this.close()}
        >
          {this.state.error}
        </div>
        {/* <Footer /> */}
      </div>
    )
  }
}

export default Addevent
